import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await api.get(`products/${id}`);
        setProduct(response.data);
      } catch (error) {
        console.error('Error fetching product details:', error);
        setMessage('Error fetching product details.');
      }
    };

    fetchProduct();
  }, [id]);

  const nextImage = () => {
    if (product?.images?.length > 1) {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % product.images.length);
    }
  };

  const prevImage = () => {
    if (product?.images?.length > 1) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
      );
    }
  };

  const addToCart = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setMessage('Please login to add products to cart.');
        return;
      }
      await api.post(
        'cart/add',
        { productId: product._id, quantity },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage('Product added to cart!');
      window.dispatchEvent(new CustomEvent('cartUpdated'));
    } catch (error) {
      console.error('Error adding product to cart:', error);
      setMessage(error.response?.data?.message || 'Error adding product to cart.');
    }
  };

  if (message && !product) {
    return <div className="container mt-5 alert alert-danger">{message}</div>;
  }

  if (!product) {
    return <div className="container mt-5">Loading product details...</div>;
  }

  return (
    <div className="container my-4">
      {message && (
        <div className="alert alert-info">{message}</div>
      )}

      {/* Carousel verticale */}
      <div className="mb-4 position-relative border rounded" style={{ overflow: 'hidden' }}>
        {product.images && product.images.length > 0 ? (
          <>
            <img
              src={`https://api.iovendosiciliano.it/${product.images[currentImageIndex]}`}
              alt={product.name}
              className="img-fluid w-100"
              style={{ maxHeight: '450px', objectFit: 'cover' }}
            />
            {product.images.length > 1 && (
              <>
                <button
                  onClick={prevImage}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '10px',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0,0,0,0.4)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: '35px',
                    height: '35px',
                    cursor: 'pointer'
                  }}
                >
                  &#9664;
                </button>
                <button
                  onClick={nextImage}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0,0,0,0.4)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: '35px',
                    height: '35px',
                    cursor: 'pointer'
                  }}
                >
                  &#9654;
                </button>
              </>
            )}
          </>
        ) : (
          <img
            src="https://via.placeholder.com/600x400"
            alt="Placeholder"
            className="img-fluid w-100"
          />
        )}
      </div>

      {/* Dettagli del prodotto in verticale */}
      <h2 className="text-success mb-3">{product.name}</h2>
      <p style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
        {product.description}
      </p>
      <p className="mb-2">
        <strong>Price:</strong> €{product.price}
      </p>
      <p className="mb-2">
        <strong>Category:</strong> {product.category}
      </p>
      <p className="mb-2">
        <strong>Stock:</strong> {product.stock}
      </p>

      {/* Se ci sono ricette, le mostriamo in un elenco semplice */}
      {product.recipes?.length > 0 && (
        <div className="mb-4">
          <h5 className="text-success">Ricette Consigliate</h5>
          <ul className="list-unstyled" style={{ paddingLeft: '1rem' }}>
            {product.recipes.map((recipe, idx) => (
              <li key={idx} className="mb-1">
                - {recipe}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Sezione Carrello */}
      <div className="mt-4 p-3 border rounded bg-light" style={{ maxWidth: '400px' }}>
        <h5 className="mb-3">Add to Cart</h5>
        <div className="d-flex align-items-center mb-3" style={{ gap: '0.75rem' }}>
          <label htmlFor="quantity" className="fw-semibold mb-0">
            Quantity:
          </label>
          <input
            type="number"
            id="quantity"
            min="1"
            className="form-control"
            style={{ width: '80px' }}
            value={quantity}
            onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
          />
        </div>
        <button className="btn btn-success" onClick={addToCart}>
          Add to Cart
        </button>
      </div>
    </div>
  );
};

export default ProductDetail;
